module.exports = __webpack_public_path__ + "static/dog-1d66460200bfe46a0dbf4f2ac32c81d7.png";